module.exports = __webpack_public_path__ + "assets/8acc32205cca5890402e355d79ab73dc.png";